import { IntegrationDataType } from '@mews-commander/data-access';

/**
 * Valid Swedish integration types for fiscal reporting.
 * This array contains the types of integrations that are considered valid for Swedish fiscal reporting.
 */
export const VALID_SWEDISH_INTEGRATION_TYPES = [IntegrationDataType.SwedishFiscalRegistryIntegration];

/**
 * The maximum number of days for which fiscal reports can be generated.
 * This constant defines the upper limit for the date range when generating fiscal reports.
 */
export const MAX_DAY_DIFFERENCE = 7;
